import React, { useState } from "react";
import logomark from "../assets/images/logo.svg";

const Modal = ({ id, isOpen, closeModal, children, showLoginButton = false }) => {
  return (
    <div className={`modal ${isOpen ? "active" : ""}`} id={id}>
      <div className="modal-box">
        <div className="modal-head">
          <img src={logomark} alt="logo" />
        </div>
        <div className="modal-contents">{children}</div>

        {/* ✅ 로그인 모달일 때만 로그인 버튼 표시 */}
        <div className="modal-btns">
          {showLoginButton && <button className="btn-primary">로그인</button>}
          {showLoginButton &&  <button className="btn-primary-outline" onClick={closeModal}>닫기</button>}
        </div>
      </div>
    </div>
  );
};

export default Modal;
